/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  boxShadow,
  maxMobile,
  maxTablet,
  maxWidth,
  minExtraLargeScreen, primaryColor, primaryFont, primaryHeadingColor,
  retina,
  secondaryFont, wMedium,
} from 'Utils/utilsStyle';
import {
  PERSON_INFO, translateSkipAreas,
} from 'Utils/Constants';
import {
  Badge, Popover, Spin, Checkbox, Divider, Switch,
} from 'antd';
import {
  MinWidthApp, backgroundColorParsing, getTimezoneInGMT, imageSource, valueToObject,
} from 'Utils/UtilityFunctions';

import { actions } from 'Slice/DocumentHubSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import classNames from 'classnames';
import RenameTextBoxGlobal from 'Components/common/components/RenameTextBoxGlobal';
import SideMenuIcon from 'Components/common/assets/svgIcons/SideMenuIcon';
import DocumentHubPopoverContent from 'Components/document/DocumentHubPopoverContent';
import {
  DocHubEntity, Document, Folder, FolderType,
} from 'Types/DocumentHubTypes';
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentFolder, selectIsAdmin, selectSapRadio } from 'Selector/DocumentHubSelector';
import DocumentParentIcon from 'Components/common/assets/svgIcons/DocumentParentIcon';
import { useNavigate } from 'react-router-dom';

const TableBody = styled.div`
  display: flex;
  align-items: center;
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #FFF;
  width: 100%;
  margin-bottom: 8px;
  border: 1px solid #fff;
  height: 80px;
  
  &.globalSearchTableBody {
    &.folderTileBody {
      .table-item-file-name {
        .file-name-size-div {
          .text-date { 
            display: flex !important;
            line-height: normal;
          }
        }
      }
    }
    padding: 0 27px;
    .table-item {
      &:first-child { // move to wrpper
        min-width: calc(100% - 742px) !important;
        max-width: calc(100% - 742px) !important;
        @media all and (max-width :${maxWidth}), ${retina} {
          min-width: calc(100% - 654px) !important;
          max-width: calc(100% - 654px) !important;
        }
      }
      &:nth-child(2) {
        min-width: unset !important;
        max-width: unset !important;
        @media all and (max-width :${maxWidth}), ${retina} {
          min-width: unset !important;
          max-width: unset !important;
        }
      }
      &:last-child {
        min-width: 100px !important;
        max-width: 100px !important;
        @media all and (max-width :${maxWidth}), ${retina} {
          min-width: 100px !important;
          max-width: 100px !important;
        }
      }
      .table-item-file-name {
       .file-name-size-div {
        row-gap: 6px;
        .file-size-folder-div {
          column-gap: 3px;
        }
        svg {
          margin-bottom: 5px;
        }
        .text-date {
          display: none;
        }
       } 
      }
    }
  }
  &.activeDrawer {
    border: 1px solid ${primaryColor};
  }
  &.active {
    border: 1px solid${primaryColor};
  }
  .table-item {
    text-align: start;
    position: relative;
    padding: 20px 5px;
    .date-time-div {
      display: flex;
      align-items: center;
      width: 100%;
      .text-date{
        width: unset;
        line-height: 15px;
        &.fileSize {
          font-size: 14px;
          line-height: 20px;
        }
      }
      .ant-divider {
        border-left: 1px solid ${primaryHeadingColor};
      }
    }
  }
  `;

const FileName = styled.div`
  display: flex;
  align-items: center;
  padding-left: 32px;
  .ant-badge {
    .ant-badge-dot {
      width: 14px;
      height: 14px;
      background-color: ${primaryColor};
      left: 23px;
      top: 5px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: 12px;
        height: 12px;
        left: 16px;
        top: 4px;
      }
    }
  }
  .file-img {
    width: 36px;
    min-width: 36px;
    height: 40px;
    margin-right: 20px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 30px;
      height: 34px;
      min-width: 30px;
      margin-right: 25px;
    }
    &.imageExtension {
      height: 35px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        height: 32px;
      }
    }
  }
  .file-name-size-div {
    display: flex;
    flex-direction: column;
    width: calc(100% - 55px);
    .file-size-folder-div {
      display: flex;
      align-items: center;
      .text-date {
        font-size: 14px;
      }
      .share-folder-person-div {
        display: flex;
        align-items: center;
        margin-left: 6px;
        .person-without-holo {
          &:nth-of-type(1) {
            z-index: 1;
          }
          &:nth-of-type(2) {
            margin-left: -10px;
          }
        }
      }
    }
    .folder-selected-items {
      color: ${primaryColor};
      font-family: ${primaryFont};
      font-size: 12px;
      font-weight: ${wMedium};
      line-height: 14px;
      letter-spacing: -0.375px;
    }
  }
  .file-name-desktop {
    font-family: ${secondaryFont};
    font-size: 20px;
    font-weight: ${wMedium};
    line-height: 24px;
    letter-spacing: -0.417px;
    color: #000;
    margin-bottom: 0px;
    text-align: left;
    cursor: pointer;
    &:visited {
      color: red;
    }
    &:hover {
      text-decoration: underline;
    }
  }
  .global-btn-delete-document{
    display: flex;
    justify-content: space-between;
  }
  .highlighted {
    color: ${primaryColor};
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
    }
  }
  .triggers-bullet-tooltip {
    .ant-tooltip-content {
      max-width: 246px;
      .ant-tooltip-inner {
        white-space: break-spaces;
      }
    }
  }
  `;

const FileInfoText = styled.span<{ statusColor?: string }>`
  font-family: ${primaryFont};
  font-size: 16px;
  font-weight: ${wMedium};
  line-height: 24px; 
  letter-spacing: -0.375px;
  color: ${primaryHeadingColor};
  /* width: 100%; */
  &.text-company {
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMedium};
    line-height: 20px;
    letter-spacing: -0.375px;
    &.global-search {
      color: ${primaryHeadingColor};
      font-size: 12px;
      line-height: 14px; 
    }
  }
  &.green {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${(props) => props.statusColor};
    padding-right: 24px;
    &.fileMenu {
      justify-content: end;
    }
    .side-menu-icon {
      position: relative;
      width: 20px;
      min-width: 20px;
      cursor: pointer;
    }
    .side-menu-popover {
      height: 23px;
      .ant-popover {
        .ant-popover-content {
          .ant-popover-arrow {
            right: 0px !important;
            height: 20px !important;
          }
          .ant-popover-inner {
            border-radius: 8px;
            .ant-popover-inner-content {
              padding: 12px 16px !important;
            }
          }
        }
      }
    }
  }
  &.searchText {
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    line-height: 23.893px;
    letter-spacing: -0.373px;
    @media all and (min-width: ${minExtraLargeScreen}) {
      font-size: 20px;
      line-height: 34px;
      letter-spacing: -0.536px;
    }
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 16px;
      line-height: 23.893px;
      letter-spacing: -0.373px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: -0.292px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 10px;
      line-height: 14.913px;
      letter-spacing: -0.186px;
    }
  }
`;
type Props = {
  tableRowId: number | null | undefined,
  setTableRowId: (id: number) => void,
  setDrawerOpenForDoc: (flag: boolean) => void,
  entity: DocHubEntity
  drawerOpen: boolean,
  hideCheckbox: boolean,
  inGlobalSearch?: boolean,
  moveToFolderWrapper?: boolean,
  handleCheckBoxClick: (id: number, isSelected: boolean, docType: FolderType, count: number) => void,
  inSmartDrawer: boolean,
  showSelected: boolean,
  loading: boolean,
  downloading: boolean,
  renameId: number,
  error: boolean,
  setError: () => void,
  downloadLoading: number[],
  type: 'folder' | 'document',
  isSelection: boolean
};

const DocumentHubTableBody = function DocumentHubTableBody(props: Props) {
  const {
    tableRowId, drawerOpen, hideCheckbox, inGlobalSearch, moveToFolderWrapper,
    inSmartDrawer, showSelected, loading, renameId, error,
    downloadLoading, entity, type, downloading: isDownloading,
    setError, setTableRowId, setDrawerOpenForDoc, handleCheckBoxClick, isSelection,
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMinTab = MinWidthApp();
  const timezone = getTimezoneInGMT();
  const host = window.location.href;

  const {
    id, time, date, isSelected, deleting, deleteAllowed,
  } = entity;

  const [active, setActive] = useState<number>(-1);
  const isAdmin = useSelector(selectIsAdmin);
  const currentFolder = useSelector(selectCurrentFolder);

  const name = type === 'folder' ? (entity as Folder).name : (entity as Document).fileName;
  const username = type === 'folder' ? (entity as Folder).createdBy : (entity as Document).username;
  const showBlip = type === 'folder' ? false : (entity as Document).showBlip;
  const downloading = type === 'folder' ? false : (entity as Document).downloading;
  const isSharedFolder = type === 'folder' ? (entity as Folder).isSharedFolder === 1 : false;
  const showPopover = type === 'folder' ? !deleting && !isSharedFolder && entity.deleteAllowed && !moveToFolderWrapper : !downloading && !downloadLoading?.includes(id) && !deleting;
  const collaborators = type === 'folder' ? (entity as Folder).collaborators : [];
  const folderType = (entity as Folder).isSharedFolder ? 'sharedFolder' : (entity as Folder).collaborators?.length ? 'companyFolder' : 'folder';
  const sapRadio = useSelector(selectSapRadio);

  const handleClick = () => {
    if (type === 'folder') {
      dispatch(actions.setCurrentFolder(entity as Folder));
      if (inGlobalSearch) {
        dispatch(actions.setFromGlobalSearch(true));
        navigate('/documents');
      }
    } else if (!isMinTab) {
      dispatch(actions.getPreviewDocument({ id, extension: (entity as Document).extension, isSap: true }));
      setDrawerOpenForDoc(true);
      setTableRowId(id);
    }
  };

  const changeHandle = (id: number) => (flag: boolean) => {
    if (flag) {
      setActive(id);
    } else {
      setActive(-1);
    }
  };

  useEffect(() => {
    if (isDownloading) {
      setActive(-1);
    }
  }, [isDownloading]);

  const handleRename = () => {
    onRename(id, name, (entity as Document).extension);
  };

  const onRename = (id: number, name: string, extension: string) => {
    dispatch(actions.setError(false));
    if (renameId > 0 && name?.length && currentFolder?.id) {
      dispatch(actions.validateFileName({
        name: `${name}`, timezone, from: 'table', folderId: currentFolder.id,
      }));
      dispatch(actions.setRenameData({
        fileName: name,
        id,
        extension: (entity as Document).extension,
      }));
    } else {
      dispatch(actions.setRenameId(id));
      if (id) {
        dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_file_edit_intent_clicked', 0, {
          user_type: isAdmin ? 'admin' : 'member',
          document_id: id,
          host,
        })));
      } else {
        dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_file_edit_cancels_clicked', 0, {
          user_type: isAdmin ? 'admin' : 'member',
          document_id: id,
          host,
        })));
      }
    }
    dispatch(actions.toggleDocumentPopover(id));
  };

  const onFolderRename = (id: number, name: string, extension: string) => {
    dispatch(actions.setError(false));
    const folderName = name.trim();
    if (renameId > 0 && folderName?.length) {
      dispatch(actions.updateFolder({
        name: folderName,
        folderId: id,
        type: 'rename',
      }));
    } else {
      dispatch(actions.setRenameId(id));
      if (id) {
        dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_file_edit_intent_clicked', 0, {
          user_type: isAdmin ? 'admin' : 'member',
          document_id: id,
          host,
        })));
      } else {
        dispatch(flurryActions.callFlurryEvent(valueToObject('documentHub_file_edit_cancels_clicked', 0, {
          user_type: isAdmin ? 'admin' : 'member',
          document_id: id,
          host,
        })));
      }
    }
    dispatch(actions.toggleDocumentPopover(id));
  };

  const handleToggleChange = (flag: boolean) => {
    dispatch(actions.updateFolder({
      gilroyToggle: flag ? 0 : 1,
      folderId: id,
      type: 'gilroyToggle',
    }));
  };

  return (
    <TableBody
      className={classNames('body-table', {
        active: (tableRowId === id && !drawerOpen) || isSelected,
        activeDrawer: tableRowId === id && drawerOpen,
        globalSearchTableBody: inGlobalSearch,
        folderTileBody: type === 'folder',
      })}
    >
      {hideCheckbox || inGlobalSearch ? null : (
        <span className={classNames('table-item')}>
          <Checkbox
            onChange={() => handleCheckBoxClick(id, isSelected, `${type}`, 1)}
            checked={isSelected}
            disabled={!inSmartDrawer ? !deleteAllowed : (showSelected && loading) || sapRadio === 'document'}
          />
        </span>
      )}
      <span className="table-item">
        <FileName className={`table-item-file-name ${translateSkipAreas}`}>
          {showBlip ? (
            <Badge dot>
              <img
                src={imageSource(type === 'folder' ? folderType : (entity as Document).extension)}
                alt="file-type-icon"
                className={classNames('file-img', {
                  imageExtension: ['png', 'jpg', 'jpeg', 'svg'].includes(type === 'folder' ? 'folder' : (entity as Document).extension),
                })}
              />
            </Badge>
          ) : (
            <img
              src={imageSource(type === 'folder' ? folderType : (entity as Document).extension)}
              alt="file-type-icon"
              className={classNames('file-img', {
                imageExtension: ['png', 'jpg', 'jpeg', 'svg'].includes(type === 'folder' ? 'folder' : (entity as Document).extension),
              })}
            />
          )}
          {renameId === id ? (
            <RenameTextBoxGlobal
              placeholder={name}
              id={id}
              setError={setError}
              extension={type === 'folder' ? '' : (entity as Document).extension}
              onRename={type === 'document' ? onRename : onFolderRename}
              onCancel={() => onRename(0, '', '')}
              errorMessage={type === 'folder' ? error ? 'Folder name already exists' : '' : error ? 'File name already exists, rename to continue uploading this file.' : ''}
            />
          ) : !isMinTab ? (
            <div className="file-name-size-div">
              {/* <Tooltip
                placement="bottomLeft"
                getPopupContainer={(e: HTMLElement) => e}
                className="triggers-bullet-tooltip"
                color="#fff"
                title={name}
                zIndex={1}
              > */}
              <span
                className={classNames('file-name-desktop  text-truncate-one-line', { highlighted: tableRowId === id && drawerOpen })}
                onClick={handleClick}
                onKeyDown={handleClick}
                tabIndex={0}
                role="button"
              >
                {name}
              </span>
              {/* </Tooltip> */}
              <div className="file-size-folder-div">
                <FileInfoText className={classNames(
                  'text-date text-truncate-one-line',
                  { fileSize: type === 'document' },
                )}
                >
                  {type === 'folder'
                    ? `${(entity as Folder).totalItems} items` : (entity as Document).fileSize}
                </FileInfoText>
                {type === 'folder' && collaborators?.length && !isSharedFolder ? (
                  <div className="share-folder-person-div">
                    {collaborators.slice(0, 2).map((c) => (
                      <PeopleWidgetWithOutHolo
                        key={c.userId}
                        logo={c.personImage}
                        persona={PERSON_INFO.archeType.color}
                        diameter="20px"
                        diameterSm="20px"
                        diameterXsm="20px"
                        ringPadding="1px"
                        ringPaddingSm="1px"
                        margin="0"
                        inGlobalSearch={inGlobalSearch}
                        wrapperColor={
                          backgroundColorParsing(c.personalityTypes)
                        }
                      />
                    ))}
                  </div>
                ) : null}
                {type === 'document' && !inGlobalSearch ? (
                  <>
                    <Divider type="vertical" />
                    <FileInfoText className="text-company text-truncate-one-line">{(entity as Document).folderName}</FileInfoText>
                  </>
                ) : type === 'document' && inGlobalSearch ? (
                  <>
                    <DocumentParentIcon />
                    <FileInfoText className="text-company global-search text-truncate-one-line">{(entity as Document).folderName}</FileInfoText>
                  </>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="file-name-size-div">
              <span
                onClick={handleClick}
                onKeyDown={handleClick}
                tabIndex={0}
                role="button"
                className="file-name-desktop text-truncate"
              >
                {name}
              </span>
              <div className="file-size-folder-div">
                <FileInfoText className="text-date text-truncate-one-line">
                  {type === 'folder'
                    ? `${(entity as Folder).totalItems} items` : (entity as Document).fileSize}
                </FileInfoText>
                {type === 'document' && !currentFolder ? (
                  <>
                    <Divider type="vertical" />
                    <FileInfoText className="text-company text-truncate-one-line">{(entity as Document).folderName}</FileInfoText>
                  </>
                )
                  : null}
              </div>
            </div>
          )}
        </FileName>
      </span>
      <span className="table-item">
        <FileInfoText className={classNames('text-truncate-one-line', { searchText: inGlobalSearch })}>{username || 'Amanda Nakra'}</FileInfoText>
      </span>
      <span className="table-item">
        {inSmartDrawer ? (
          <div className={classNames('date-time-div', { uploadedOn: inSmartDrawer })}>
            {/* <Tooltip
              placement="top"
              getPopupContainer={(e: HTMLElement) => e}
              className="triggers-bullet-tooltip"
              color="#fff"
              title={entity.time}
              zIndex={1}
            > */}
            <FileInfoText className="text-date text-truncate-one-line">{date}</FileInfoText>
            {/* </Tooltip> */}
          </div>
        ) : (
          <div className="date-time-div">
            <FileInfoText
              className={classNames('text-date', 'text-truncate-one-line', { searchText: inGlobalSearch })}
            >
              {date}
            </FileInfoText>
            <Divider type="vertical" />
            <FileInfoText
              className={classNames('text-date', 'text-truncate-one-line', { searchText: inGlobalSearch })}
            >
              {time}
            </FileInfoText>
          </div>
        )}
      </span>
      <span className={classNames('table-item', { indexZero: active === id })}>
        {inGlobalSearch ? (
          <FileInfoText className={classNames('text-truncate-one-line')}>
            {entity.fileSize}
          </FileInfoText>
        ) : (
          <FileInfoText
            className={classNames('green', { fileMenu: type !== 'folder' })}
          >
            {type === 'folder' ? (
              <Switch
                className="switch-div"
                checked={(entity as Folder).gilroyToggle === 0}
                onClick={handleToggleChange}
              />
            ) : null}
            {showPopover
              ? (
                <Popover
                  onOpenChange={changeHandle(id)}
                  getPopupContainer={() => document.querySelector('.infinite-document-hub') as HTMLElement || document.body}
                  content={(
                    <DocumentHubPopoverContent
                      entity={entity}
                      type={type}
                      onRename={handleRename}
                    />
                  )}
                  trigger="click"
                  placement="left"
                  className="side-menu-popover"
                >
                  <span className={classNames({
                    indexOne: active === id,
                    disabled: isSelected || isSelection,
                  })}
                  >
                    <SideMenuIcon color={active === id ? primaryColor : '#A0A0A0'} />
                  </span>
                </Popover>
              ) : null}
            {deleting || downloading || downloadLoading?.includes(id) ? (
              <Spin />
            ) : null}
          </FileInfoText>
        )}
      </span>
    </TableBody>
  );
};

export default DocumentHubTableBody;
